import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface AIMessageProps {
  role: 'user' | 'assistant';
  content: string;
  provider?: string;
  model?: string;
  tokens?: number;
  timestamp?: string;
}

export default function AIMessage({ role, content, provider, model, tokens, timestamp }: AIMessageProps) {
  if (role === 'user') {
    return (
      <div className="flex justify-end mb-4">
        <div className="max-w-2xl bg-blue-600 text-white rounded-2xl rounded-br-sm px-4 py-3">
          <p className="text-sm whitespace-pre-wrap">{content}</p>
          {timestamp && (
            <p className="text-xs text-blue-200 mt-1 text-right">{timestamp}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start mb-4">
      <div className="max-w-2xl">
        <div className="bg-white border border-gray-200 rounded-2xl rounded-bl-sm px-4 py-3">
          <div className="prose prose-sm max-w-none prose-p:my-2 prose-code:bg-gray-100 prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-pre:bg-gray-900 prose-pre:text-gray-100 prose-pre:rounded-lg">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          </div>
        </div>
        <div className="flex items-center gap-2 mt-1 px-1">
          {provider && (
            <span className="text-xs text-gray-400">
              {provider === 'vsends' ? 'VSENDS AI' : provider}
              {model && ` · ${model}`}
            </span>
          )}
          {tokens && tokens > 0 && (
            <span className="text-xs text-gray-400">{tokens} tokens</span>
          )}
          {timestamp && (
            <span className="text-xs text-gray-400">{timestamp}</span>
          )}
        </div>
      </div>
    </div>
  );
}
